import React from 'react';
import { SentWrapperStyled, SentByStyled, SentAsStyled } from './sent.styled';

interface SentByProps {
  createdBy: string;
  sentAsName: string;
}

export const SentBy = ({ createdBy, sentAsName }: SentByProps) => {
  return (
    <SentWrapperStyled>
      Sent by &nbsp;
      <SentByStyled>{createdBy}</SentByStyled>
      &nbsp; as: &nbsp;
      <SentAsStyled>{sentAsName}</SentAsStyled>
    </SentWrapperStyled>
  );
};
